/* eslint-disable react/prop-types */
import React from 'react';
import cn from 'clsx';
import { ReactComponent as ArrowDownIcon } from 'assets/icons/New/arrow-down-icon.svg';
import { ATable } from 'components/Antd';
import { getColumns, rowIsExpand, rowIsArchived, filteredData } from './utils';
import classes from './ComplianceTable.module.scss';

const ComplianceTable = ({
  className,
  onArchive,
  onDelete,
  onEdit,
  onRenew,
  onDuplicate,
  onUnarchive,
  onUpdateDocument,
  data,
  type,
}) => {
  const columns = getColumns({
    onArchive,
    onDelete,
    onEdit,
    onRenew,
    onDuplicate,
    onUnarchive,
    type,
    onUpdateDocument,
  });
  const subColumns = getColumns({
    onArchive,
    onDelete,
    onEdit,
    onRenew,
    onDuplicate,
    onUnarchive,
    type,
    onUpdateDocument,
    isSub: true,
  });

  return (
    <div
      className={cn(
        classes.wrapper,
        {
          [classes.wrapperTest]: type === 'test',
          [classes.wrapperCertificate]: type === 'certificate',
          [classes.wrapperOther]: type === 'other',
        },
        className
      )}>
      <ATable
        columns={columns}
        className={classes.table}
        rowClassName={(record) => {
          return rowIsArchived(record) ? classes.expiredRow : '';
        }}
        expandable={{
          rowExpandable: (record) => {
            return rowIsExpand(record);
          },
          expandedRowRender: (record) => {
            return (
              <ATable
                columns={subColumns}
                dataSource={record.subs || []}
                hidePagination
                className={classes.subTable}
                rowClassName={(tRecord) => {
                  return rowIsArchived(tRecord) ? classes.expiredRow : '';
                }}
              />
            );
          },
          expandIcon: ({ expanded, onExpand, record }) => (
            <span className={classes.expandIcon}>
              {rowIsExpand(record) && (
                <>
                  {expanded ? (
                    <ArrowDownIcon
                      onClick={(e) => onExpand(record, e)}
                      className={classes.expandedIcon}
                    />
                  ) : (
                    <ArrowDownIcon
                      onClick={(e) => onExpand(record, e)}
                      className={classes.collapsedIcon}
                    />
                  )}
                </>
              )}
            </span>
          ),
        }}
        dataSource={filteredData(data, type).map((obj, index) => ({
          ...obj,
          key: index + 1,
        }))}
        hidePagination
        scroll={{
          x: 1100,
        }}
      />
    </div>
  );
};

export default ComplianceTable;
